import { addFilter, vafpFilterItems } from "@/redux/features/vafpFilterSlice";
import axiosInstance from "@/service/axiosInstance";
import { customSelectStyle } from "@/styles/customStyles";
import { APP_NAME } from "@/utils/enum";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";

type DropdownPSAProps = {
  handleResetFilter: any;
  setCurrentPage: any;
  getData: any;
  currentPage: any;
  isMobile?: boolean;
  closeMobileModal?: any;
};

const DropdownVafp: React.FC<DropdownPSAProps> = ({
  handleResetFilter,
  setCurrentPage,
  getData,
  currentPage,
  isMobile,
  closeMobileModal,
}) => {
  const filter = useSelector(vafpFilterItems);
  const dispatch = useDispatch();
  const gradesMapping: any = useRef({});
  const [loading, setLoading] = useState(false);
  const [formOptions, setFormOptions] = useState<any>({
    schools: [],
    grades: [],
  });
  const [schoolLoading, setShoolLoading] = useState(false);

  const userRole = useSelector((state: any) => state.auth.userRole);

  const getSchools = async () => {
    try {
      const data = await axiosInstance.get("/locations");
      if (!data.data) {
        toast.error("Failed to fetch schools");
        return [];
      } else {
        let schoolData: any = [];
        data.data.map((doc: any) => {
          schoolData.push({
            value: doc?.attributes?.School_Name?.data?.attributes?.name,
            label: doc?.attributes?.School_Name?.data?.attributes?.name,
          });
        });

        const sortedSchoolData = schoolData.sort((a: any, b: any) => {
          const schoolA = a.value.toUpperCase();
          const schoolB = b.value.toUpperCase();

          if (schoolA < schoolB) {
            return -1;
          }
          if (schoolA > schoolB) {
            return 1;
          }
          return 0;
        });

        return sortedSchoolData;
      }
    } catch (error: any) {
      console.log("Error in getting locations :>> ", error.data || error);
      return [];
    }
  };

  const getGrades = async () => {
    try {
      const { data } = await axiosInstance.get("/grade");

      let structuredGradeData: any = [];

      for (let i = 0; i < data.length; i++) {
        structuredGradeData.push({
          label: data[i]?.attributes?.name,
          value: data[i]?.attributes?.Calculation_Value,
          order: data[i]?.attributes?.order,
        });
      }

      structuredGradeData.sort((a: any, b: any) => a.order - b.order);
      const newGradesMapping = structuredGradeData.reduce(
        (acc: any, obj: any) => {
          acc[obj.label] = obj;
          return acc;
        },
        {},
      );

      newGradesMapping["Sr. K.G."] = newGradesMapping["Sr.KG"];
      newGradesMapping["Jr. K.G."] = newGradesMapping["Jr.KG"];

      gradesMapping.current = { ...newGradesMapping };

      return structuredGradeData;
    } catch (error: any) {
      console.log("Error in loading grades :>> ", error.data || error);
      return [];
    }
  };

  const getFormOptions = async () => {
    try {
      setLoading(true);
      const schools = await getSchools();
      const grades = await getGrades();

      if (schools && grades) {
        setFormOptions({ schools, grades });
      } else {
        toast.error("Unable to find schools & grades");
      }
    } catch (error) {
      toast.error(
        "Unable to process data at this moment, Please try again later",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSchoolChange = (e: any) => {
    setShoolLoading(true);
    dispatch(addFilter({ ...filter, schools: e }));
    setShoolLoading(false);
  };

  const handleGradeChange = (e: any) => {
    dispatch(addFilter({ ...filter, grades: e }));
  };

  useEffect(() => {
    getFormOptions();
    // Force rerender when filter changes
    if (filter?.schools || filter?.grades) {
      // No need to do anything here, as the value prop on the Select components
      // will pick up the changes from the filter
    }
  }, [filter]);

  // console.log("filter-", filter);

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        setCurrentPage(0);
        const updatedFilter = { ...filter, currentPage: 1 };
        dispatch(addFilter(updatedFilter));
        // console.log("Updated filter:", updatedFilter);
        getData(0, {
          school: filter?.schools?.value,
          grade: filter?.grades?.value,
        });
      }}
    >
      <div className="row gx-lg-5">
        <div className="col-12">
          {isMobile && (
            <button
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                background: "none",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                color: "#666",
                width: "36px",
                height: "36px",
              }}
              onClick={() => closeMobileModal()}
            >
              <i className="fa-light fa-close"></i>
            </button>
          )}
          <div
            className="col-12"
            style={{
              marginBottom: "0.938rem",
            }}
          >
            <div
              style={{
                color: "#212121",
                fontWeight: "500",
                fontSize: "2rem",
                marginBottom: "1.25rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {" "}
              Filter{" "}
            </div>
            {process.env.NEXT_PUBLIC_APP_NAME !== APP_NAME.VIBGYOR_ONE && (
              <div
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                Event
              </div>
            )}
          </div>

          <div className="col-12">
            <div
              style={{
                marginBottom: "0.938rem",
              }}
            >
              <div
                className="label"
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                Venue School
              </div>
              <Select
                className="custom-select"
                isClearable
                instanceId="selectbox1"
                onChange={handleSchoolChange}
                options={formOptions?.schools}
                value={filter?.schools}
                isDisabled={filter?.schools && filter?.enrollmentNumber !== ""}
                isLoading={loading || !formOptions?.schools?.length}
                styles={customSelectStyle}
              />
            </div>
          </div>

          <div className="col-12">
            <div
              style={{
                marginBottom: "0.938rem",
              }}
            >
              <div
                className="label"
                style={{
                  color: "#212121",
                  fontWeight: "500",
                  fontSize: "1.25rem",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                Grade
              </div>
              <Select
                className="custom-select"
                isClearable
                instanceId="selectbox3"
                onChange={handleGradeChange}
                options={formOptions?.grades}
                value={filter?.grades}
                isDisabled={filter?.grades && filter?.enrollmentNumber !== ""}
                isLoading={loading || !formOptions?.grades?.length}
                styles={customSelectStyle}
              />
            </div>
          </div>
        </div>
        <div className="col-12">
          <button
            className="fw-300 apply-search w-100 mt-20 mb-25"
            style={{
              borderRadius: "2.5rem",
            }}
            type="submit"
          >
            <i className="fa-light fa-magnifying-glass"></i>
            <span
              style={{
                fontSize: "0.875rem",
                fontWeight: 500,
              }}
            >
              Search
            </span>
          </button>
        </div>

        <div className="col-12">
          <div className="d-flex justify-content-center form-widget">
            <a
              onClick={handleResetFilter}
              style={{ cursor: "pointer" }}
              className="tran3s"
            >
              <i className="fa-regular fa-arrows-rotate"></i>
              <span
                style={{
                  fontWeight: 400,
                  fontSize: "1rem",
                }}
              >
                Reset Filter
              </span>
            </a>
          </div>
        </div>
      </div>
    </form>
  );
};

export default DropdownVafp;
